import { FeeSchedule, FeeScheduleControllerApi } from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

/**
 * @author Rajkumar Rathod
 */
export const useCreateFeeSchedule = () =>
  useMutationWithLoading(
    async (params: { feeSchedule: FeeSchedule; xTENANTID?: string }) =>
      new FeeScheduleControllerApi(getConfigObject()).createFeeSchedule(
        params.feeSchedule,
        params.xTENANTID
      )
  );
